import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import RichTextEditor from './RichTextEditor';

interface FormRichTextFieldProps {
  name: string;
  label: string;
  required?: boolean;
  helperText?: string;
  rows?: number;
}

/**
 * react-hook-form wrapper around the presentational RichTextEditor. Keeps the
 * editor UI (toolbar, math symbols, Quill config) in a single place.
 */
const FormRichTextField: React.FC<FormRichTextFieldProps> = ({
  name,
  label,
  required = false,
  helperText,
  rows = 4
}) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange, onBlur },
    fieldState: { error }
  } = useController({
    name,
    control
  });

  return (
    <RichTextEditor
      value={value || ''}
      onChange={onChange}
      onBlur={onBlur}
      label={label}
      required={required}
      helperText={helperText}
      error={error?.message}
      rows={rows}
    />
  );
};

export default FormRichTextField;
